import AppListing from "./AppListing";
import { useDispatch } from "react-redux";
import {
  deleteOption,
  editOption,
  viewOption,
} from "client/Components/Administraton/utils/constant";
import UserManagementOperations from '../../../../../../redux/UserManagement/operations'

const AppListingConatiner = (props: any) => {
  const dispatch = useDispatch()
  const dispatchApplicationById = UserManagementOperations.dispatchApplicationById(dispatch);

  const optionHandler = (evt: any, option: any, prop: any) => {
    if (option.value === editOption.value) {
      props.setSelectedKey('app-onboarding');
      props.setSelectedOption("edit");
      dispatchApplicationById(prop.id)
    }
    if (option.value === viewOption.value) {
      props.setSelectedKey('app-onboarding');
      props.setSelectedOption("view");
      dispatchApplicationById(prop.id)
    }
    if (option.value === deleteOption.value) {
      props.setShowDeleteModal(true);
      props.setSelectedId(prop.id)
      props.setSelectedName(prop.applicationName)
    }
  };

  return (
    <AppListing
      setSelectedKey={props.setSelectedKey}
      setSelectedOption={props.setSelectedOption}
      setShowDeleteModal={props.setShowDeleteModal}
      setSelectedId={props.setSelectedId}
      setSelectedName={props.setSelectedName}
      showDeleteModal={props.showDeleteModal}
      handleDeleteClick={props.handleDeleteClick}
      handleDeleteModal={props.handleDeleteModal}
      handleInfoModal={props.handleInfoModal}
      showInfoModal={props.showInfoModal}
      selectedName={props.selectedName}
      optionHandler={optionHandler}
    />
  )
}

export default AppListingConatiner;